
export const notNull = (value) => value !== null;
